import * as gl from './ServiceListGames';

export const games = (_rc='', _country='')=>{
    let list = [];

    switch ( _country ) {
        case "KR":
        case "NC":
            list = [
                gl.tl(_rc),
                gl.lineagew(_rc),
                gl.bns2(_rc),
                gl.tricksterm(_rc),
                gl.h3(_rc),
                gl.lineage2m(_rc),
                gl.lineagem(_rc),
                gl.h2(_rc),
                gl.bns(_rc),
                gl.aion(_rc),
                gl.lovebeat(_rc),
                gl.lineage2(_rc),
                gl.lineage(_rc)
            ]
        break;

        case "TW" : //대만 
            list = [gl.lineagew(_rc)];
        break;
        case "JP" : //일본 
            list = [gl.lineagew(_rc)];
        break;
        case "RU" : //러시아 
            list = [gl.lineage2m(_rc)];
        break;
        case "ID" : //인도네시아 
            list = [gl.lineagew(_rc)];
        break;
        case "TH" : //태국 
            list = [gl.lineagew(_rc)];
        break;
        case "MY" : //말레이시아 
            list = [gl.lineagew(_rc)];
        break;
        case "SA" : //사우디아라비아 
            list = [gl.lineagew(_rc)];
        break;
        case "AE" : //아랍에미리트 
            list = [gl.lineagew(_rc), gl.lineage2m(_rc)];
        break;
        case "QA" : //카타르 
            list = [gl.lineagew(_rc)];
        break;
        case "HK" : //홍콩 
            list = [gl.lineagew(_rc)];
        break;
        case "SG" : //싱가포르 
            list = [gl.lineagew(_rc)];
        break;
        case "PH" : //필리핀 
            list = [gl.lineagew(_rc)];
        break;
        case "US" : //미국 
            list = [gl.lineage2m(_rc)];
        break;
        case "CA" : //캐나다 
            list = [gl.lineage2m(_rc)];
        break;
        case "DE" : //독일 
            list = [gl.lineage2m(_rc)];
        break;
        case "GB" : //영국 
            list = [gl.lineage2m(_rc)];
        break;
        case "FR" : //프랑스 
            list = [gl.lineage2m(_rc)];
        break;
        case "BR" : //브라질 
            list = [gl.lineage2m(_rc)];
        break;
        case "IT" : //이탈리아 
            list = [gl.lineage2m(_rc)];
        break;
        case "ES" : //스페인 
            list = [gl.lineage2m(_rc)];
        break;
        case "CL" : //칠레 
            list = [gl.lineage2m(_rc)];
        break;
        case "NO" : //노르웨이 
            list = [gl.lineage2m(_rc)];
        break;
        case "SE" : //스웨덴 
            list = [gl.lineage2m(_rc)];
        break;
        case "IE" : //아일랜드 
            list = [gl.lineage2m(_rc)];
        break;
        case "PT" : //포르투갈 
            list = [gl.lineage2m(_rc)];
        break;
        case "FI" : //핀란드 
            list = [gl.lineage2m(_rc)];
        break;
        case "DK" : //덴마크 
            list = [gl.lineage2m(_rc)];
        break;
        case "CH" : //스위스 
            list = [gl.lineage2m(_rc)];
        break;
        case "AR" : //아르헨티나 
            list = [gl.lineage2m(_rc)];
        break;
        case "PE" : //페루 
            list = [gl.lineage2m(_rc)];
        break;
        case "MX" : //멕시코 
            list = [gl.lineage2m(_rc)];
        break;
        case "KZ" : //카자흐스탄 
            list = [gl.lineage2m(_rc)];
        break;

        case "UZ" : //우즈베키스탄 
            list = [gl.lineage2m(_rc)];
        break;
        case "AZ" : //아제르바이잔 
            list = [gl.lineage2m(_rc)];
        break;
        case "GE" : //조지아 
            list = [gl.lineage2m(_rc)];
        break;
        case "MD" : //몰도바 
            list = [gl.lineage2m(_rc)];
        break;
        case "AM" : //아르메니아 
            list = [gl.lineage2m(_rc)];
        break;

        case "UA" : //우크라이나 
            list = [gl.lineage2m(_rc)];
        break;
        case "PL" : //폴란드 
            list = [gl.lineage2m(_rc)];
        break;
        case "GR" : //그리스 
            list = [gl.lineage2m(_rc)];
        break;
        case "BY" : //벨라루스 
            list = [gl.lineage2m(_rc)];
        break;
        case "LT" : //리투아니아 
            list = [gl.lineage2m(_rc)];
        break;
        case "IL" : //이스라엘 
            list = [gl.lineage2m(_rc)];
        break;
        case "KW" : //쿠웨이트 
            list = [gl.lineage2m(_rc)];
        break;
        case "AT" : //오스트리아 
            list = [gl.lineage2m(_rc)];
        break;
        case "VN" : //베트남 
        break;
    }

    return list;
}